/**
 * Load More Component
 * Handles infinite scroll / load more pagination for collections
 */

if (!customElements.get('load-more')) {
  customElements.define(
    'load-more',
    class LoadMore extends HTMLElement {
      constructor() {
        super();
        this._button = this.querySelector('button');
        this._nextPage = 2;
        this._isLoading = false;
        this._productGrid = document.querySelector('#product-grid');
        this._collectionTemplate = document.querySelector('main');
        this._productCount = this.querySelector('#product-count');
      }

      connectedCallback() {
        this.bindEvent();
        this._productGrid.classList.remove('opacity-0');
      }

      addParamsToUrl(url, params) {
        let urlObj = new URL(url, window.location.origin);
        let searchParams = urlObj.searchParams;

        for (let key in params) {
          searchParams.set(key, params[key]);
        }

        return urlObj.href;
      }

      bindEvent() {
        this._button.addEventListener('click', () => {
          this.expandShowMore();
        });
      }

      async expandShowMore() {
        if (this._isLoading) return;
        this._isLoading = true;

        const searchParams = new URLSearchParams(window.location.search);
        const url = this.getAttribute('collection-handle') + '?' + searchParams;

        //grab current filters & params
        let paramsObj = {
          page: this._nextPage
        };

        const newURL = this.addParamsToUrl(url, paramsObj);

        fetch(newURL)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const countEl = html.querySelector('#collection-count');
            const collectionCount = countEl.getAttribute('count');
            // Sections that skip some products while rendering (e.g. wholesale
            // gating on the v8 grid) expose total-pages so the button can hide
            // on the last page even though fewer cards than `count` rendered.
            const totalPages = parseInt(countEl.getAttribute('total-pages'));
            const products = html.querySelector('#product-grid').children;

            Array.from(products).forEach((product) => {
              this._productGrid.appendChild(product);
            });

            if (
              this._productGrid.childElementCount >= parseInt(collectionCount) ||
              (!isNaN(totalPages) && this._nextPage >= totalPages)
            ) {
              this._button.classList.add('!hidden');
            }

            this._nextPage++;
            this._isLoading = false;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
